export const LIST = "COMPANY_PERFORMANCE_BY_DAY_LISTING";